import useVaults from '@/application/read/vaults/useVaults';
import CollectionVault from './CollectionVault';
import { Asset } from 'nftx.js';
import { useMemo } from 'react';

const CollectionVaultContainer = ({
  vaultId,
  collectionAssets,
  type,
  onClick,
}: {
  vaultId: string;
  collectionAssets: Asset[];
  type: 'buy' | 'sell';
  onClick: () => void;
}) => {
  const { data: vaults } = useVaults();

  const vault = vaults?.find((x) => x.vaultId === vaultId);
  const totalHoldings = useMemo(() => {
    if (type === 'buy') {
      return vault?.totalHoldings;
    }
    return collectionAssets.filter((asset) => asset.vaultIds.includes(vaultId))
      .length;
  }, [collectionAssets, type, vault?.totalHoldings, vaultId]);
  const price = useMemo(() => {
    if (type === 'buy') {
      return vault?.prices?.[0]?.redeem?.price;
    }
    return vault?.prices?.[0]?.mint?.price;
  }, [type, vault?.prices]);

  return (
    <CollectionVault
      name={vault?.token.name}
      vaultId={vaultId}
      price={price}
      totalHoldings={totalHoldings}
      onClick={onClick}
      type={type}
    />
  );
};

export default CollectionVaultContainer;
